module.exports = __webpack_public_path__ + "media/images/weather/258_day-66b093ea2f5018e408f1f7cfa9717b4a.png";